import React, { createContext, useContext } from 'react';
import { BuyerProjectData } from '@/types';

export interface OptionsScope {
    residentialUnitId: number;
    projectData: BuyerProjectData;
    /** 'buyer' or 'seller'. Both can sign; signing is only blocked while impersonating (see `useIsImpersonating`). */
    mode: 'buyer' | 'seller';
    /**
     * True when the viewer may not change selections — a seller impersonating a buyer.
     * Mirrors the signing block; computed once where the scope is built.
     */
    readOnly: boolean;
    /**
     * Whether the sign-and-send / submit affordances are available. False in the anonymous showroom,
     * which lets visitors make trial selections (so `readOnly` is false) but has no signing flow.
     */
    showSubmit: boolean;
}

const OptionsScopeContext = createContext<OptionsScope | null>(null);

export const OptionsScopeProvider: React.FC<{ value: OptionsScope; children: React.ReactNode }> = ({
    value,
    children,
}) => <OptionsScopeContext.Provider value={value}>{children}</OptionsScopeContext.Provider>;

export function useOptionsScope(): OptionsScope {
    const scope = useContext(OptionsScopeContext);
    if (!scope) {
        throw new Error('useOptionsScope must be used inside <OptionsScopeProvider>');
    }
    return scope;
}
